// extracted by mini-css-extract-plugin
export default {"updatenotebook_container":"updatenotebookform_updatenotebook_container__BnMP9","updatenotebook_wrap":"updatenotebookform_updatenotebook_wrap__y0RC-"};